import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";

class UnderwritingBody extends Component {
  render() {
    return (
      <div>
        <div className="data-line">
          <span>Business Class: </span>
          <span className="value-data">
            {this.props.data.BusinessClassifcation}
          </span>
        </div>
        <div className="data-line">
          <span>Web Business Class: </span>
          <span className="value-data">{this.props.data.WebBusinessClass}</span>
        </div>
        <div className="data-line">
          <span>Date Business Established: </span>
          <span className="value-data">
            {FormatUtils.formatDate(this.props.data.DateEstablishedBusiness)}
          </span>
        </div>
        <div className="data-line">
          <span>Years of Industry Experience (Owner): </span>
          <span className="value-data">
            {this.props.data.YearsOfIndustryExperience} yrs.
          </span>
        </div>
        <div className="data-line">
          <span>Revenue Prior: </span>
          <span className="value-data">
            {FormatUtils.formatMoney(this.props.data.RevenuePrior)}
          </span>
        </div>
        <div className="data-line">
          <span>Revenue Current: </span>
          <span className="value-data">
            {FormatUtils.formatMoney(this.props.data.RevenueCurrent)}
          </span>
        </div>
        <div className="data-line">
          <span>Revenue Projected: </span>
          <span className="value-data">
            {FormatUtils.formatMoney(this.props.data.RevenueProjected)}
          </span>
        </div>
        <div className="data-line">
          <span>Number of Employees: </span>
          <span className="value-data">{this.props.data.NumberOfEmployee}</span>
        </div>
        <div className="data-line">
          <span>FEIN: </span>
          <span className="value-data">{this.props.data.FEIN}</span>{" "}
          <span> | Legal Entity: </span>
          <span className="value-data">{this.props.data.LegalEntity}</span>
        </div>
        <div className="data-line">
          <span>Prior Claim: </span>
          <span className="value-data">
            {this.props.data.PriorClaim && this.props.data.PriorClaim
              ? "Y"
              : "N"}
          </span>
        </div>
        <div className="data-line">
          <span>Description of Operation: </span>
          <span className="value-data">
            {FormatUtils.formatLongText(
              this.props.data.DescriptionOfOperation,
              170
            )}
          </span>
        </div>
      </div>
    );
  }
}

export default UnderwritingBody;
